/* unplugin-vue-components disabled */
import WaveSurfer from 'wavesurfer.js'
import RecordPlugin from 'wavesurfer.js/dist/plugins/record.esm.js'
import {FileUpload} from 'stores/files'
import {API_CHATS} from 'consts/api'

export default {
  inject: {
    di_recording: {
      from: 'di_recording',
      default: false
    }
  },
  emits: ['transcribed'],
  data() {
    return {
      recording: false,
      sending: false,
      ws: null,
      rec: null,
      blob: null,
    }
  },
  computed:{
    active(){
      return this.recording || this.sending
    }
  },
  watch: {
    active(val){
      this.di_recording = val
    }
  },
  mounted() {
    this.ws = WaveSurfer.create({
      container: this.$refs.container,
      waveColor: '#f63d69',
      cursorWidth: 0,
      responsive: true,
      barGap: 2,
      barWidth: 2,
      height: 36,
    })

    this.rec = this.ws.registerPlugin(RecordPlugin.create({
      scrollingWaveform: true,
      renderRecordedAudio: false,
      mimeType: 'audio/webm;codecs=opus',
      audioBitsPerSecond: 24000,
      scrollingWaveformWindow: 15,
    }))

    this.rec.on('record-end', (blob) => {
      this.blob = blob
    })

    this.rec.on('record-progress', async (time) => {
      const mins = Math.floor((time % 3600000) / 60000)
      if (mins >= 5) { // max 5 minutes
        await this.confirm()
      }
    })
  },
  beforeUnmount() {
    if (this.rec) this.rec.stopRecording()
    if (this.ws) this.ws.destroy()
    this.ws = null
    this.rec = null
  },
  methods: {
    async start() {
      this.blob = null
      try {
        await this.rec.startMic()
        await this.rec.startRecording()
        this.recording = true
      } catch (error) {
        $utils.toasts.error('Microphone permission denied. Please enable it in your browser settings.')
      }

    },
    async cancel() {
      await this.rec.stopRecording()
      this.blob = null
      this.recording = false
    },
    stopAndGetBlob() {
      if (this.blob) return Promise.resolve(this.blob)
      return new Promise((resolve, reject) => {
        const handler = (blob) => {
          this.rec.un?.('record-end', handler) || this.rec.off?.('record-end', handler)
          this.blob = blob
          resolve(blob)
        }
        this.rec.on('record-end', handler)
        try {
          this.rec.stopRecording()
        } catch (e) {
          this.rec.un?.('record-end', handler) || this.rec.off?.('record-end', handler)
          reject(e)
        }
      })
    },
    async confirm() {
      const blob = await this.stopAndGetBlob()
      this.recording = false

      this.sending = true
      const file = new File([blob], 'audio.webm', {type: blob.type})
      const upload = new FileUpload(file, {}, {
        endpoint: `${API_CHATS}/transcribe`, 
        resolve: async (result) => {
          this.$emit('transcribed', result.text)
          this.sending = false
        }})
      await upload.start()
      this.blob = null
    }
  }
}
